
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
  Label,
} from "recharts";

const CustomBarChart = (props) => {
  const {chartData:data} = props
  const CustomizedAxisTick = (props) => {

      const { x, y,payload } = props;
  
      return (
        <g transform={`translate(${x},${y})`}>
          <text x={0} y={0} dy={16} textAnchor="end" fill="#666" transform="rotate(-35)">
            {payload.value}
          </text>
        </g>
      );
    
  }

  return (
    <div className="h-[350px] w-full mt-[1rem]">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          height={300}
          width={500}
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 20,
          }}
        >
          <XAxis dataKey="name" height={90}  tick={CustomizedAxisTick} domain={['', '']} angle={45} includeHidden padding={{ left: 5, right: 5 }}>
            <Label value="Date" offset={-5} position="insideBottom" />
          </XAxis>
          <YAxis domain={[0,10]}
            label={{ value: "Measure", angle: -90, position: "insideLeft" }}
          />
          <Tooltip />
          <Bar dataKey="measure" maxBarSize={40}>
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={entry?.color}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CustomBarChart;
